import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles({
  container: {
    marginTop: 5
  },
  table: {
    minWidth: '100%'
  },
  trashIcon: {
    cursor: 'pointer'
  }
});

const TableCellTitleStrong = withStyles((theme) => ({
  head: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
  head: {
    borderBottom: 'none !important'
  },
  body: {
    wordBreak: 'break-word'
  }
}))(TableCell);

const StrWeakTable = ({ strweak, onClickDelete }) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table aria-label="a dense table" className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCellTitleStrong />
            <TableCellTitleStrong align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {strweak.map((stwk) => (
            <TableRow key={stwk.name}>
              <StyledTableCell component="th" scope="row">
                {stwk.name}
              </StyledTableCell>
              <TableCell align="right">
                <DeleteOutlineIcon
                  className={classes.trashIcon}
                  color="error"
                  fontSize="small"
                  onClick={() => {
                    onClickDelete(stwk.name);
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StrWeakTable;
